module.exports = __webpack_public_path__ + "static/media/icon-desktop.f44046f0.svg";